import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSnackbar,{attrs:{"value":_vm.isShown,"color":_vm.messageStyle.background},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c(VBtn,{attrs:{"color":_vm.messageStyle.button,"text":""},on:{"click":_vm.closeMessage}},[_vm._v(" "+_vm._s(_vm.$t('Close'))+" ")])]},proxy:true}])},[(_vm.message)?[_vm._v(" "+_vm._s(_vm.message.text)+" ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }